import { BuildInfo } from '../helpers';

export enum UserActivityParameter {
  CustomerNumber = '[[CustomerNumber]]',
  OrderName = '[[OrderName]]',
  ProductNumber = '[[ProductNumber]]',
  DeliverDate = '[[DeliveryDate]]',
  OrderEntryHeaderId = '[[OrderEntryHeaderId]]',
  FromPage = '[[FromPage]]',
  UserId = '[[UserId]]',
  PendingUserId = '[[PendingUserId]]',
  CustomerId = '[[CustomerId]]',
}

export enum UserActivityAction {
  BeginEditOrder = 'Begin Order Edit',
  CancelEditOrder = 'Cancel Order Edit',
  CreateOrder = 'Create Order',
  CreateItemOrder = 'Create Item Order',
  DeleteOrder = 'Delete Order',
  Login = 'Login',
  Logout = 'Logout',
  SubmitOrder = 'Submit Order',
  SendOrderForApproval = 'Send Order For Approval',
  RejectOrder = 'Reject Order',
  UpdateUserProfile = 'Update User Profile',
  Visit = 'Visit',
  ExportARData = 'Export AR Data',
  SendContactEmailVerification = 'Send Contact Email Verification',
  DownloadInvoiceDocument = 'Download',
  DownloadMultipleInvoiceDocuments = 'Download Multiple Invoice PDFs',
  DownloadInvoiceProofOfDeliveryDocument = 'Download Invoice Proof Of Delivery',
  ViewAccountReceivableStatement = 'View AR Statement',
  DownloadProductListImportTemplate = 'Download Product List Import Template',
  CreateProductList = 'Create Product List',
  CopyProductList = 'Copy Product List',
  ImportProductList = 'Import Product List',
  DeleteProductList = 'Delete Product List',
  ShareProductList = 'Share Product List',
  ExportProductList = 'Export Product List',
  PrintProductList = 'Print Product List',
  RepeatOrder = 'Repeat Order',
  RecallFutureOrder = 'Recall Order',
  RunReport = 'Run Report',
  RunTemplateReport = 'Run Template Report',
  SaveInsight = 'Save Insight',
  SubmitEditOrder = 'Submit Order Edit',
  CreateParGuide = 'Create Par Guide',
  CopyParGuide = 'Copy Par Guide',
  DeleteParGuide = 'Delete Par Guide',
  ResetParLevels = 'Reset Par Levels',
  ResendInvite = 'Resend Invite',
  InviteNewUser = 'Invite New Users',
  AddUserToLocation = 'Add User To Location',
  RemoveUserFromLocation = 'Remove User From Location',
  UpdatePermissions = 'Update Permissions',
  DeleteVendor = 'Delete Vendor',
  DeleteInvoiceHeader = 'Delete Third Party Invoice Header',
  SubmitPrice = 'Submitted Third Party Invoice Price',
  UpdateInvoiceDetails = 'Update the Third Party Invoice Details',
  DeleteInvoiceDetail = 'Delete Third Party Invoice Detail',
  UpdateInvoiceHeader = 'Update the Third Party Invoice Header',
  CreateInvoiceHeader = 'Create the Third Party Invoice Header',
  GetThirdPartyInvoiceDetils = 'Fetch the Third Party Invoice Details',
  QuickAddThirdparty = 'added thirdparty invoice',
  DeleteVendorProduct = 'Delete Vendor Product',
  SubmitInventory = 'Submit Inventory',
  InventoryWorksheetPrint = 'Inventory Worksheet Print',
  InventoryWorksheetExport = 'Inventory Worksheet Export',
  MenuDetails = 'Menu Details',

  InventoryValuationPrint = 'Inventory Valuation Print',
  InventoryValuationExport = 'Inventory Valuation Export',

  InventoryConsumptionPrint = 'Inventory Consumption Print',
  InventoryConsumptionExport = 'Inventory Consumption Export',

  InventoryCostAnalysisPrint = 'Inventory Cost Analysis Print',
  InventoryCostAnalysisExport = 'Inventory Cost Analysis Export',

  ApproveInventory = 'Approve Inventory',
  ClearInventoryOnHand = 'Clear Inventory On Hand',
  EditInventoryInReview = 'Edit Inventory In Review',
  UpdateApprovedInventoryToReview = 'Update Approved Inventory To Review',
  MergeSubmittedInventory = 'Merge Submitted Inventory',
  DeleteInReviewInventory = 'Delete In Review Inventory',
  DeleteApprovedInventory = 'Delete Approved Inventory',

  CreateMenu = 'Create Menu',
  EditMenu = 'Edit Menu',
  DeleteMenu = 'Delete Menu',
  CopyMenu = 'Copy Menu',
  RevertDeletedMenu = 'Restore Deleted Menu',
  UpdateMenuDetails = 'Update Menu Recipes',
  DeleteMenuDetail = 'Remove Menu Recipe',

  GetMenuWorkSheetList = 'Fetch Menus WorkSheet List',
  CreateMenuWorkSheet = 'Create Menu WorkSheet',
  UpdateMenuWorkSheet = 'Update Menu WorkSheet',
  DeleteMenuWorkSheet = 'Delete Menu WorkSheet',

  ManagePrivateMenuUsers = 'Managed Secret Menu Users',

  CreateRecipe = 'Create Recipe',
  EditRecipe = 'Edit Recipe',
  UpdateHiddenRecipe = 'Update Hidden Recipe',
  UpdateSecretRecipe = 'Update Secret Recipe',
  DeleteRecipe = 'Delete Recipe',
  CreateRecipeCategory = 'Create Recipe Category',
  EditRecipeCategory = 'Edit Recipe Category',
  DeleteRecipeCategory = 'Delete Recipe Category',
  CreateIngredient = 'Create Ingredient',
  EditIngredient = 'Edit Ingredient',
  DeleteIngredient = 'Delete Ingredient',
  CreateIngredientCategory = 'Create Ingredient Category',
  EditIngredientCategory = 'Edit Ingredient Category',
  DeleteIngredientCategory = 'Delete Ingredient Category',
  ShareRecipe = 'Share Recipe',
  CopyRecipe = 'Copy Recipe',
  RevertDeletedRecipe = 'Restore Deleted Recipe',
  RevertDeletedIngredient = 'Restore Deleted Ingredient',
  ManageSharedRecipeUsers = 'Managed Shared Recipe Users',
  ManagePrivateRecipeUsers = 'Managed Secret Recipe Users',

  RecipeCostingPrint = 'Recipe Costing Print',
  RecipeCostingExport = 'Recipe Costing Export',
  RecipeMenuCostingPrint = 'Recipe Menu Costing Print',
  RecipeMenuCostingExport = 'Recipe Menu Costing Export',
  RecipeDetailReportPrint = 'Recipe Detail Report Print',
  RecipeDetailReportExport = 'Recipe Detail Report Export',

  CreateSageConversation = 'Create Sage Conversation',
  CreateSageConversationMessage = 'Create Sage Conversation Message',
  UpdateSageConversationMessage = 'Update Sage Conversation Message',
  SageConversationViewMore = 'Sage Conversation View More',

  DocumentLibraryDownloadFile = 'Download File',
  DocumentLibraryVisitExternalURL = 'Visit External URL',
  DownloadOrderReviewDocument = 'Download',
}

export enum UserActivityPageName {
  Home = 'Home',
  Login = 'Login',
  Logout = 'Logout',
  NoUserInformation = 'No User Information',
  ListManagement = 'List Management',
  ListDetail = 'List Detail',
  ListNotification = 'List Notification',
  CopyProductList = 'Copy Product List',
  ProductListDelete = 'Delete Product List',
  ProductListShare = 'Share Product List',
  ProductListImport = 'Product List Import',
  ProductListExport = 'Product List Export',
  OrderConfirmation = 'Order Confirmation',
  OrderDetails = 'Order Details',
  OrderEntry = 'Order Entry',
  ItemOrder = 'Item Order',
  OrderImport = 'Order Import',
  OrderReview = 'Order Review',
  OrderHistory = 'Order History',
  RepeatOrder = 'Repeat Order',
  ParManagement = 'Par Management',
  VendorManagement = 'Vendor Management',
  ThirdPartyInvoices = 'ThirdPartyInvoices',
  ThirdPartyInvoicePrice = 'ThirdPartyInvoicePrice',
  QuickAddThirdPartyInvoice = 'QuickAddThirdPartyInvoice',
  ThirdPartyInvoiceDetail = 'ThirdPartyInvoiceDetail',
  AddFromVendor = 'Add From Vendor',
  AddEditVendor = 'Add/Edit Vendor',
  ShareVendor = 'Share Vendor',
  VendorDetails = 'Vendor Details',
  VendorProductDetails = 'Vendor Product Details',
  AddEditVendorProduct = 'Add/Edit Vendor Product',
  ParDetail = 'Par Detail',
  DeleteParGuide = 'Delete Par Guide',
  CopyParGuide = 'Copy Par Guide',
  PasswordReset = 'Password Reset',
  ProductCompare = 'Product Compare',
  ProductDetails = 'Product Details',
  DeliveryDetails = 'Delivery Detail',
  AccountsReceivableStatements = 'AR Statements',
  AccountsMakePayment = 'AR Statements Make Payment',
  HomepageMakePayment = 'Homepage Make Payment',
  HomepageARStatements = 'Homepage AR Statement',
  Insights = 'Insights',
  InsightsDashboard = 'Insights Dashboard',
  InsightsReport = 'Insights Report',
  Invoices = 'Invoices',
  InvoiceDetail = 'Invoice Detail',
  InvoiceExport = 'Invoice Export',
  SearchAnalysis = 'Search Analysis',
  UI = 'UI',
  UserProfile = 'User Profile',
  CustomerSupport = 'Customer Support',
  CreateMessage = 'Create Message',
  MessageGroups = 'Message Groups',
  ViewMessageGroup = 'View Message Group',
  CreateMessageGroup = 'Create Message Group',
  UpdateMessageGroup = 'Update Message Group',
  InboxMessages = 'Message Inbox',
  ViewInboxMessage = 'View Inbox Message',

  DraftMessages = 'Message Draft',
  ViewDraftMessage = 'View Draft Message',

  SentMessages = 'Message Sent',
  ViewSentMessage = 'View Sent Message',

  Search = 'Search',
  ListDetailSearch = 'List Detail Search',
  FindSimilarSearch = 'Find Similar Search',
  CustomerSupportAccount = 'Customer Support Account',
  CustomerSupportOrdering = 'Customer Support Ordering',
  CustomerSupportInvoices = 'Customer Support Invoices',
  CustomerSupportListManagement = 'Customer Support List Management',
  CustomerSupportParManagement = 'Customer Support Par Management',
  CustomerSupportRecipes = 'Customer Support Recipes',
  CommunicationPreferences = 'Communication Preferences',
  ManageUsers = 'Manage Users',
  ManageUsersExport = 'Manage Users Export',
  CategorySearch = 'Category Search',

  CustomerGroups = 'Customer Groups',
  ViewCustomerGroup = 'View Customer Group',
  CreateCustomerGroup = 'Create Customer Group',

  InventoryEntry = 'Inventory Entry',
  InventoryWorksheet = 'Inventory Worksheet',
  InventorySnapshot = 'Inventory Snapshot',
  InventoryValuation = 'Inventory Valuation',
  InventoryConsumption = 'Inventory Consumption',
  InventoryCostAnalysis = 'Inventory Cost Analysis',
  SmartOrder = 'Smart Order',

  Menus = 'Menus',
  MenuDetails = 'Menu Details',
  MenuWorkSheets = 'MenuWorkSheets',
  PrivateMenuUsers = 'Private Menu',
  MenuDiary = 'Menu Diary',
  MenuCustomerDiary = 'Menu Customer Diary',

  Recipes = 'Recipes',
  RecipeCategories = 'Recipe Categories',
  RecipeDetail = 'Recipe Detail',
  Ingredients = 'Ingredients',
  IngredientCategories = 'Ingredient Categories',
  IngredientDetail = 'Ingredient Detail',
  BrowseRecipe = 'Browse Recipes',
  RecipeDashbaord = 'Recipe Dashboard',
  SharedRecipeUsers = 'Shared Recipe Users',
  PrivateRecipeUsers = 'Private Recipe',
  RecipeCustomerDiary = 'Recipe Customer Diary',
  RecipeDiary = 'Recipe Diary',
  IngredientCustomerDiary = 'Ingredient Customer Diary',
  IngredientDiary = 'Ingredient Diary',
  RecipeCosting = 'Recipe Costing',
  RecipeMenuCosting = 'Recipe Menu Costing',
  RecipeDetailReport = 'Recipe Detail Report',
  ManageRecipeAccess = 'Manage Recipe Access',
  RecipeNotifications = 'Recipe Notifications',

  SageConversation = 'Sage Conversation',

  DocumentLibrary = 'Document Library',

  OrderReviewExport = 'Order Review Export',

  CustomerProductRecommendations = 'Customer Product Recommendations',
}

export enum UserActivityActionSummary {
  CancelledEditingOrder = 'User cancelled editing a submitted order',
  CreateProductList = 'User Created Product List From List Management',
  CopyProductList = 'User Copied Product List',
  ProductListImport = 'User Imported Product List',
  ProductListDelete = 'User delete custom list',
  ProductListShare = 'User Shared Product List',
  ProductListExport = 'User Exported Product List',
  ProductListPrint = 'User Printed Product List',
  UserExportedARData = 'User Exported AR Data',
  CreateOrderFromHeader = 'Created Order from Header Menu, Customer:[[CustomerNumber]]',
  CreateItemOrderFromHeader = 'Created Item Order from Header Menu, Customer:[[CustomerNumber]]',
  CreateOrderFromHome = 'Created Order from Home New Order Button, Customer:[[CustomerNumber]]',
  CreateOrderFromRecentOrders = 'Created Order from Order History New Order Button, Customer:[[CustomerNumber]]',
  CreateOrderFromImport = 'Created Order from Import, Customer:[[CustomerNumber]]',
  CreateRepeatOrder = 'User Created a Repeat Order from [[FromPage]]',
  RecalledFutureOrder = 'User Recalled a Order from [[FromPage]], Customer:[[CustomerNumber]], Order:[[OrderEntryHeaderId]]',
  DeletedOrder = 'User Deleted Order, Customer:[[CustomerNumber]], Order Name:[[OrderName]]',
  SentOrderForApproval = 'User Submitted an Order for Approval',
  RejectedOrder = 'User Rejected an Order',
  DownloadInvoiceDocument = 'User downloaded invoice export',
  DownloadMultipleInvoiceDocuments = 'User downloaded multiple invoice PDFs',
  DownloadInvoiceProofOfDeliveryDocument = 'User Download Invoice Proof Of Delivery',
  DownloadAccountReceivableStatement = 'User Downloaded AR Statement',
  DownloadProductListImportTemplate = 'User Downloaded Product List Import Template',
  SentContactEmailVerification = 'User Sent Contact Email Verification',
  SubmittedOrder = 'User Submitted an Order, Customer:[[CustomerNumber]], Order Name:[[OrderName]]',
  StartedEditingOrder = 'User started editing a submitted order',
  SubmittdEditOrder = 'User submitted an edit on a submitted order',
  SuccessfullyLoggedIn = 'User Successfully Logged in',
  SuccessfullyLoggedOut = 'User Successfully Logged out from Header Menu',
  UserUpdatedPassword = 'User Reset their Password',
  UserUpdatedUserProfile = 'User Updated User Profile',
  VisitedAccountsReceivableStatements = 'User Visited AR Statements',
  VisitedAccountsMakePayment = 'User Clicked AR Statements Make Payment',
  VisitedHomepageMakePayment = 'User Clicked Homepage Make Payment',
  VisitedInvoiceDetail = 'User Visited Invoice Detail',
  VisitedHomePage = 'User Visited Home Page, Customer:[[CustomerNumber]]',
  VisitedInvoices = 'User Visited Invoices',
  VisitedInvoicesExport = 'User Visited Invoices Export',
  VisitedListDetail = 'User Visited List Detail',
  VisitedParDetail = 'User Visited Par Detail',
  VisitedListManagement = 'User Visited List Management',
  VisitedListNotification = 'User Visited List Notifications',
  VisitedOrderDetails = 'User Visited Order Detail',
  VisitedOrderConfirmation = 'User Visited Order Confirmation Page, Customer:[[CustomerNumber]], Order Delivery Date:[[DeliveryDate]]',
  VisitedItemOrder = 'User Visited Item Order [[OrderEntryHeaderId]]',
  VisitedOrderEntry = 'User Visited Order Entry [[OrderEntryHeaderId]]',
  VisitedOrderReview = 'User Visited Order Review [[OrderEntryHeaderId]]',
  VisitedOrderImport = 'User Visited Order Import, Customer:[[CustomerNumber]]',
  VisitedParManagement = 'User Visited Par Management',
  VisitedVendorManagement = 'User visited vendor management',
  VisitedAddEditVendor = 'User visited the add/edit dialog for third party vendors',
  VisitedShareVendor = 'User visited the dialog to share a third party vendor',
  VisitedVendorDetails = 'User visited third party vendor details',
  VisitedVendorProductDetails = 'User visited third party vendor product details',
  VisitedAddEditVendorProduct = 'User visited the add/edit dialog for third party vendor products',
  VisitedPasswordReset = 'User Visited Password Reset',
  VisitedProductCompare = 'User Visited Product Compare Page, Customer:[[CustomerNumber]]',
  VisitedProductDetails = 'User Visited Product Details Page, Customer:[[CustomerNumber]], Product:[[ProductNumber]]',
  VisitedProductListExport = 'User visited List Export Page',
  VisitedOrderHistory = 'User Visited Order History Page, Customer:[[CustomerNumber]]',
  VisitedRepeatOrder = 'User Visited Repeat Order Page, Customer:[[CustomerNumber]]',
  VisitedDeliveryDetails = 'User Visited Delivery Detail',
  VisitedInsightsDashboard = 'User Visited Insights Dashboard',
  VisitedFindSimilarSearch = 'User Visited Find Similar Search for product: #[[ProductNumber]]',
  VisitedSearch = 'User Visited Search',
  VisitedAddFromVendor = 'User Visited Add From Vendor',
  VisitedMenuDetails = 'User Visited Menu Details',
  VisitedListDetailSearch = 'User Visited List Detail Search',
  VisitedMessageInbox = 'User Visited Message Inbox',
  VisitedMessageDraft = 'User Visited Message Draft',
  VisitedMessageSent = 'User Visited Message Sent',
  VisitedMessageGroups = 'User Visited Message Groups',
  VisitedCustomerGroups = 'User Visited Customer Groups',
  VisitedCustomerSupportAccount = 'User Visited Customer Support Account',
  VisitedCustomerSupportOrdering = 'User Visited Customer Support Ordering',
  VisitedCustomerSupportInvoices = 'User Visited Customer Support Invoices',
  VisitedCustomerSupportListManagement = 'User Visited Customer Support List Management',
  VisitedCustomerSupportParManagement = 'User Visited Customer Support Par Management',
  VisitedCommunicationPreferences = 'User Visited Communication Preferences',
  RanReport = 'User Ran Insight Report',
  RanTemplateReport = 'User Ran Insight Template Report',
  SavedInsights = 'User Saved Insights Report',
  VisitedUserProfile = 'User Visited Profile',
  CreatedParGuide = 'User Created Par Guide From Par Management',
  DeletedVendor = 'User Deleted the Third Party Vendor Detail from Vendor Management',
  DeletedThirdPartyInvoice = 'User Deleted Third Party Invoice Header From Third Party Invoice',
  SubmitPrice = 'User Has Submitted Third Party Invoice Price',
  UpdateInvoiceDetails = 'User Has Updated the Third Party Invoice Details',
  DeletedThirdPartyInvoiceDetail = 'User Deleted Third Party Invoice Detail From Third Party Invoice',
  UpdateThirdPartyInvoice = 'User Updated Third Party Invoice Header',
  CreateThirdPartyInvioce = 'User Created the Third Party Invoice Header',
  GetThirdPartyInvoiceDetails = 'User Visited the Third Party Invice Details Page',
  GetThirdPartyInvoiceDetail = 'User Visited the Third Party Invice Detail Page',
  QuickAddThirdPartyInvoice = 'Added Third Party Invoices details',
  DeletedVendorProduct = 'User Deleted the Third Party Vendor Product from Vendor Product Details',
  CopyParGuide = 'User Copied Par Guide',
  DeletedParGuide = 'User Deleted Par Guide',
  ResetParLevels = 'User Reset Par Levels',
  ResendInvite = 'Site User Resent Invitation to: [[PendingUserId]]',
  InviteNewUser = 'Site User Invited a New User: [[PendingUserId]]',
  AddUserToLocation = 'Site User Added User: [[UserId]] to Location: [[CustomerId]]',
  RemoveUserFromLocation = 'Site User Removed User: [[UserId]] from Location: [[CustomerId]]',
  UpdateExistingUserPermissions = 'Site User Updated User: [[UserId]] User/Customer Permissions for Location: [[CustomerId]]',
  UpdateNewUserPermissions = 'Site User Set Pending User: [[PendingUserId]] User Permissions',

  VisitedInventoryEntry = 'Visited Inventory Entry',
  SubmittedInventory = 'Submitted Inventory',
  VisitedInventoryWorksheet = 'Visited Inventory Worksheet',
  InventoryWorksheetPrint = 'User Printed Inventory Worksheet',
  InventoryWorksheetExport = 'User Exported Inventory Worksheet',
  VisitedInventorySnapshot = 'Visited Inventory Snapshot',

  VisitedInventoryValuation = 'Visited Inventory Valuation',
  InventoryValuationPrint = 'User Printed Inventory Valuation',
  InventoryValuationExport = 'User Exported Inventory Valuation',

  VisitedInventoryConsumption = 'Visited Inventory Consumption',
  InventoryConsumptionPrint = 'User Printed Inventory Consumption',
  InventoryConsumptionExport = 'User Exported Inventory Consumption',

  VisitedInventoryCostAnalysis = 'Visited Inventory Cost Analysis',
  InventoryCostAnalysisPrint = 'User Printed Inventory Cost Analysis',
  InventoryCostAnalysisExport = 'User Exported Inventory Cost Analysis',

  ApproveInventory = 'User Approved Inventory',
  ClearInventoryOnHand = 'User Cleared Inventory On Hand',
  EditInventoryInReview = 'User Edited Inventory In Review',
  UpdateApprovedInventoryToReview = 'User Updated Approved Inventory To Review',
  MergeSubmittedInventory = 'User Merged Submitted Inventory',
  DeleteInReviewInventory = 'User Deleted In Review Inventory',
  DeleteApprovedInventory = 'User Deleted Approved Inventory',

  VisitedMenus = 'User Visited Menus Page',
  CreateMenu = 'User Created New Menu',
  UpdateMenu = 'User Updated Menu List',
  DeleteMenu = 'User Deleted Menu From List',
  RevertDeletedMenu = 'User Restored Deleted Menu',
  CopyMenu = 'User Copied Menu',
  VisitedMenuDiary = 'User Visited Menu Diary',
  VisitedMenuCustomerDiary = 'User Visited Menu Customer Diary',

  UpdateMenuDetails = 'User Updated Menu Recipes',
  DeleteMenuDetail = 'User Removed Menu Recipe',

  GetMenuWorksheetList = 'User Visitied Menus Worksheet Page',
  CreateMenuWorksheet = 'User Create New Menu Worksheet',
  UpdateMenuWorksheet = 'User Updated Menu Worksheet List',
  DeleteMenuWorksheet = 'User Deleted Menu Worksheet From List',

  ManagePrivateMenuUsers = 'User Managed Secret Menu Users',

  VisitedRecipeDashboard = 'User Visited Recipe Dashboard',
  VisitedBrowseRecipes = 'User Visited Browse Recipes',
  VisitedRecipes = 'User Visited Recipes',
  VisitedRecipeDetail = 'User Visited Recipe Detail',
  VisitedIngredients = 'User Visited Ingredients',
  VisitedIngredientDetail = 'User Visited Ingredient Detail',
  VisitedRecipeDiary = 'User Visited Recipe Diary',
  VisitedIngredientDiary = 'User Visited Ingredient Diary',
  VisitedCustomerRecipeDiary = 'User Visited Customer Recipe Diary',
  VisitedCustomerIngredientDiary = 'User Visited Customer Ingredient Diary',

  CreateRecipe = 'User Created Recipe',
  EditRecipe = 'User Edited Recipe',
  UpdateHiddenRecipe = 'User Updated Hidden Recipe Headers',
  UpdateSecretRecipe = 'User Updated Secret Recipe Headers',
  DeleteRecipe = 'User Deleted Recipe',
  CreateRecipeCategory = 'User Created Recipe Category',
  EditRecipeCategory = 'User Edited Recipe Category',
  DeleteRecipeCategory = 'User Deleted Recipe Category',
  CreateIngredient = 'User Created Ingredient',
  EditIngredient = 'User Edited Ingredient',
  DeleteIngredient = 'User Deleted Ingredient',
  CreateIngredientCategory = 'User Created Ingredient Category',
  EditIngredientCategory = 'User Edited Ingredient Category',
  DeleteIngredientCategory = 'User Deleted Ingredient Category',
  ShareRecipe = 'User Managed Shared Recipe',
  CopyRecipe = 'User Copied Recipe',
  RevertDeletedRecipe = 'User Restored Deleted Recipe',
  RevertDeletedIngredient = 'User Restored Deleted Ingredient',
  ManageSharedRecipeUsers = 'User Managed Shared Recipe Users',
  ManagePrivateRecipeUsers = 'User Managed Secret Recipe Users',

  VisitedRecipeCosting = 'User Visited Recipe Costing',
  RecipeCostingPrint = 'User Printed Recipe Costing',
  RecipeCostingExport = 'User Exported Recipe Costing',
  VisitedRecipeMenuCosting = 'User Visited Recipe Menu Costing',
  RecipeMenuCostingPrint = 'User Printed Recipe Menu Costing',
  RecipeMenuCostingExport = 'User Exported Recipe Menu Costing',
  VisitedRecipeDetailReport = 'User Visited Recipe Detail Report',
  RecipeDetailReportPrint = 'User Printed Recipe Detail Report',
  RecipeDetailReportExport = 'User Exported Recipe Detail Report',

  VisitedRecipeNotification = 'User Visited Recipe Notifications',
  VisitedManageRecipeAccess = 'User Visited Manage Recipe Access',

  CreateSageConversation = 'User Started A New Conversation With Sage',
  CreateSageConversationMessage = 'User Sent A Message To Sage',
  UpdateSageConversationMessage = 'User Rated A Response From Sage',
  SageConversationViewMore = 'User View More More Products From Sage',

  VisitedDocumentLibrary = 'User Visited Document Library',
  DocumentLibraryDownloadFile = 'User downloaded a file from Document Library',
  DocumentLibraryVisitExternalURL = 'User visited an external URL from Document Library',

  VisitedOrderReviewExport = 'User visted order review export',
  DownloadOrderReviewDocument = 'User downloaded order review export',

  VisitedCustomerProductRecommendations = 'User Visited Customer Product Recommendations',
}

export interface LogUserActivityRequest<T = undefined> {
  Action: UserActivityAction;
  PageName: UserActivityPageName;
  ActionSummary: string;
  SessionId: string;
  BrowserName: string;
  BrowserVersion: string;
  Resolution: string;
  CustomerId: string;
  AdditionalData?: T | BuildInfo;
}
